import React, { useLayoutEffect, useState } from 'react'
import styled from 'styled-components'
import queryString from 'query-string'
import Loader from '../components/Loader'
import SplitPassages from '../containers/PassagesSplit'
import { palette } from '../styles/branding'
import { changeColorMode } from '../helpers/helpers'
import { useMultipleStops } from '../hooks/useMultipleStops.hooks'
import { useParams } from 'react-router-dom'

import {
  calculateAmountOfPassagesPerStop,
  getStopsByColumns,
} from '../helpers/multimaxiSplit.helpers'

const Layout = styled.div`
  height: 100vh;
  background: ${(props) => (props.light ? palette.neutral1 : '#3b3b3b')};
`
const Grid = styled.div`
  display: ${(props) => (props.fullWidth ? 'block' : 'flex')};
  height: 100%;
  overflow: hidden;
`
const Col = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  width: ${(props) => (props.fullWidth ? '100%' : '50%')};
  ${(props) => props.fullWidth && 'height: 100%;'}
  &:first-child {
    border-right: 5px solid #ccc;
  }
`

const MultimaxiSplit = () => {
  const [col1MaxItems, setCol1MaxItems] = useState(0)
  const [col2MaxItems, setCol2MaxItems] = useState(0)
  const { haltenummers } = useParams()
  const { stops = [], isLoading } = useMultipleStops()

  const colProps = [
    {
      items: getStopsByColumns(stops).c1(),
      maxItems: col1MaxItems,
      setMax: setCol1MaxItems,
    },
    {
      items: getStopsByColumns(stops).c2(),
      maxItems: col2MaxItems,
      setMax: setCol2MaxItems,
    },
  ]

  useLayoutEffect(() => {
    if (stops.length) {
      colProps.forEach(({ items, setMax }) => {
        setMax(
          calculateAmountOfPassagesPerStop({
            amountOfStopsInCol: items.length,
          }),
        )
      })
    }
  }, [stops])

  if (isLoading) {
    return <Loader />
  }

  const queryParam = queryString.parse(window.location.search)
  const lightMode = changeColorMode(queryParam.inverse)
  const isFullWidth = haltenummers?.split('+').length === 1

  return (
    <Layout light={lightMode}>
      <Grid fullWidth={isFullWidth}>
        {colProps.map((col, idx) => (
          <Col key={`split-col-${idx}`} fullWidth={isFullWidth}>
            {col.items.map((stop) => (
              <SplitPassages
                key={stop.id}
                limit={col.maxItems || 1}
                stop={stop}
              />
            ))}
          </Col>
        ))}
      </Grid>
    </Layout>
  )
}

MultimaxiSplit.propTypes = {}
MultimaxiSplit.defaultProps = {}

export default MultimaxiSplit
